const keys = new WeakMap()
let nextKey = 0

export function columnDragKey (component) {
  if (!component || typeof component !== 'object') return 'column-0'
  let key = keys.get(component)
  if (!key) {
    nextKey += 1
    key = `column-${nextKey}`
    keys.set(component, key)
  }
  return key
}
